<template>
  <div>
    <MTab :index="1"/>
  </div>
</template>

<script>
/**
 * 动态
 */
export default {
  name: 'DeviceDynamic'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/device/DeviceDynamic.vue